import axios, { AxiosError } from 'axios'
import { ApiResponse } from '@axilon-apps/libs-shared-api'

import type {
  EntitiesCreateSessionResponse,
  WebErrorResponse
} from '../api/axilon-v2-api.generated'
import AuthenticationStorage from '../../shared/core/services/authentication-token'
import type { ApiExtraOptions, RequestParams } from '../api/types'

class ApiService {
  constructor(private baseUrl: string) {}

  public async request(params: RequestParams, { public: isPublic }: ApiExtraOptions) {
    return this.http({
      ...params,
      headers: this.headers(params.headers, isPublic, AuthenticationStorage.accessToken?.token)
    })
  }

  public authenticate() {
    return this.http<EntitiesCreateSessionResponse, WebErrorResponse>({
      url: '/api/v2/sessions/refresh',
      method: 'post',
      data: { refreshToken: AuthenticationStorage.refreshToken?.token },
      params: {},
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  private async http<T, E>(params: RequestParams) {
    try {
      const { baseUrl: paramsBaseUrl, token: _token, ...axiosConfig } = params
      const baseUrl = paramsBaseUrl ?? this.baseUrl
      return new ApiResponse<T, E>(
        await axios<T>({
          ...axiosConfig,
          url: baseUrl + params.url
        })
      )
    } catch (error) {
      throw new ApiResponse<T, E>(error as AxiosError<E>)
    }
  }

  private headers(headers: RequestParams['headers'], isPublic: boolean, token?: string) {
    return {
      ...headers,
      ...(!isPublic && token ? { Authorization: `Bearer ${token}` } : {})
    }
  }
}

export default ApiService
